import styled, { css } from 'styled-components';
import { Constants } from '@shared/ui-components';

const Container = styled.div`
  box-sizing: border-box;
  transition: all 0.2s ease;
  align-items: center;
  background: ${p => p.theme.color.background};
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  line-height: 1.4;
  padding: 8px 10px 7px 10px;
`;


const Input = styled.input`
  border: 0;
  outline: 0;
  font-size: inherit;
  line-height: inherit;
  width: 100%;

  font-size: 12px;
  line-height: 16px;
  color: ${p => p.theme.color.mainFont};
  background-color: transparent;
  &::placeholder{
    color: ${p => p.theme.color.disabled};
  }
`;

const DefaultTag = css`
  background: ${p => p.theme.color.backgroundRush};
  color: ${p => p.theme.color.mainFont};
  svg {
    fill: ${Constants.Colors.GENERAL_COLORS.red};
  }
`;

const ErrorTag = css`
  background-color: ${Constants.Colors.GENERAL_COLORS.red};
  color: ${Constants.Colors.GENERAL_COLORS.white};

  svg {
    fill: ${Constants.Colors.GENERAL_COLORS.white};
  }
`;

interface TagProps {
  hasProblem?: boolean;
}
const Tag = styled.span<TagProps>`
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  background: ${p => p.theme.color.backgroundRush};
  color: ${p => p.theme.color.mainFont};
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  padding: 3px 5px;
  align-items: center;
  max-width: 100%;

  > span{
    height: 14px;
    max-width: calc(100% - 15px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    width: 10px;
    height: 10px;
    margin-left: 5px;
  }

  ${p => p.hasProblem ? ErrorTag : DefaultTag};
`;

export const Styled = {
  Container,
  Input,
  Tag,
  DefaultTag,
  ErrorTag,
};
